import axios from "axios";
import { Config } from "./Config"; 
const originalLog = console.log;
const originalError = console.error;
const originalWarn = console.warn;
const originalInfo = console.info;

const sendLogToServer = (type, args) => {
  const payload = {
    type,
    message: args
      .map(arg => {
        try {
          return typeof arg === "object"
            ? JSON.stringify(arg)
            : String(arg);
        } catch {
          return String(arg);
        }
      })
      .join(" "),
    time: new Date().toISOString(),
  };

  axios
    .post(
      Config.API_BASE_PATH + Config.SAVE_LOG,
      payload
    )
    .catch(() => {});
};

console.log = (...args) => {
  originalLog(...args);
  sendLogToServer("LOG", args);
};

console.error = (...args) => {
  originalError(...args);
  sendLogToServer("ERROR", args);
};

console.warn = (...args) => {
  originalWarn(...args);
  sendLogToServer("WARN", args);
};

console.info = (...args) => {
  originalInfo(...args);
  sendLogToServer("INFO", args);
};